export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=5eef95fe"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/content/index.vue?vue&type=template&id=5eef95fe
// module id = ydjn
// module chunks = 0